import { useCallback, useMemo, useState } from "react";

export function useSprintSelection(sprints) {
  const [selectedIds, setSelectedIds] = useState([]);

  // Recarregar o projeto pode devolver outra lista: manter um id que sumiu
  // faria o contador falar de uma sprint que não está na tabela.
  const availableIds = useMemo(() => sprints.map((sprint) => sprint.id), [sprints]);
  const liveIds = useMemo(
    () => selectedIds.filter((id) => availableIds.includes(id)),
    [selectedIds, availableIds]
  );

  const isSelected = useCallback((id) => liveIds.includes(id), [liveIds]);

  const toggle = useCallback((id) => {
    setSelectedIds((current) =>
      current.includes(id) ? current.filter((selected) => selected !== id) : [...current, id]
    );
  }, []);

  const clear = useCallback(() => setSelectedIds([]), []);

  const allSelected = availableIds.length > 0 && liveIds.length === availableIds.length;
  const someSelected = liveIds.length > 0 && !allSelected;

  const toggleAll = useCallback(() => {
    setSelectedIds(allSelected ? [] : availableIds);
  }, [allSelected, availableIds]);

  return {
    selectedIds: liveIds,
    isSelected,
    toggle,
    toggleAll,
    clear,
    allSelected,
    someSelected,
  };
}
